





































import { Component, Vue, Prop } from 'vue-property-decorator'
import ProjectForm from './ProjectForm.vue'
import { Project } from '@/model/Project'
import { DigInputController } from '@digithia/input'
import store from '@/store'

@Component({
  components: { ProjectForm },
})
export default class NewProject extends Vue {
  @Prop({ required: true }) targetUserId!: number
  @Prop({ default: false }) isAdmin!: boolean

  project: Project = {}

  get loggedUserId(): number {
    return store.getters.loggedUser.id
  }

  get targetUserDisplayName(): string {
    if (this.targetUserId === this.loggedUserId) {
      return (
        store.getters.loggedUser.firstname +
        ' ' +
        store.getters.loggedUser.lastname
      )
    }

    const users = store.getters.users
    const targetUser = users.find((user: any) => user.id === this.targetUserId)
    if (targetUser) {
      return targetUser.firstname + ' ' + targetUser.lastname
    }

    return `User ID: ${this.targetUserId}`
  }

  updateProjectField({
    field,
    value,
  }: {
    field: keyof Project
    value: any
  }): void {
    this.project[field] = value
  }

  cancel(): void {
    this.$emit('cancel', this.project)
  }

  validate(): void {
    if (!DigInputController.checkInputsValidity('.new-project')) {
      this.$store.dispatch('toaster/toast', {
        type: 'warning',
        message: this.$t('invalidForm'),
      })
    } else {
      this.$emit('validate', this.project)
    }
  }
}
